//PlayFormButtonControlView

import { View } from 'backbone';
import eventBus         from 'EventBus';
import constants from 'Constants';
import BaseControlView from 'BaseControlView';
import template from 'advanced-inputs/control_play_form_button.ejs';

//=====================================================================
//
// An instance of this view represents a show report button control
//
// Maty Rocha, Feburary 26, 2016
//
//=====================================================================
class PlayFormButtonControlView extends BaseControlView  {

    initialize( opts ) {

        super.initialize( opts );

        this.template = template;

        this.tagName = 'div';
        this.subfamily = constants.CONTROL_INSTANCE;

        this.listenTo(this.model, 'change', this.render);
        this.listenTo( eventBus, 'ButtonThemeChange', this.themeChangeRender);
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
        return this;
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'PlayFormButtonControlView';
    }


}

export default PlayFormButtonControlView;
